export default "__VITE_ASSET__f7834ab0__"